export default class Scenario {
	constructor() {
        this.id = "";
        this.name = "";
        this.storyID = "";
        this.story = null;
        this.problemModel = null;
        this.availableIcon = null;
        this.disabledIcon = null;
        this.castIds = [];
    }
}

